import type { QueueBoardRoom } from "./types";

export function clinicRoomToBoard(r: {
  roomNumber?: string;
  roomName?: string;
  doctorName?: string;
}): QueueBoardRoom | null {
  const id = String(r?.roomNumber ?? "").trim();
  if (!id) return null;
  const nameRaw = String(r?.roomName ?? "").trim();
  const docRaw = String(r?.doctorName ?? "").trim();
  return {
    id,
    name: nameRaw || `Room ${id}`,
    doctorName: docRaw || "—",
    currentQueue: 0,
  };
}

export function mergeRoomWithLive(
  room: QueueBoardRoom,
  liveByRoomId: Record<string, number>
): QueueBoardRoom {
  const key = String(room.id).trim();
  const q = liveByRoomId[key];
  if (q != null && Number.isFinite(q) && q >= 0) return { ...room, currentQueue: q };
  return room;
}

export function getRoomPathSegment(pathname: string): string | undefined {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length < 2 || parts[0].toLowerCase() !== "room") return undefined;
  return parts[1];
}

const WEEK_DAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
] as const;

export function getTodayWeekDay(): string {
  return WEEK_DAYS[new Date().getDay()];
}
